import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-icon-flag-eng',
  templateUrl: './icon-flag-eng.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconFlagEngComponent {}
